import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { PlayCircle, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaTriagemIniciada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('triagem iniciada') || 
           acaoLower.includes('iniciou triagem') ||
           acaoLower.includes('iniciar triagem');
};

const getIconTriagemIniciada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: PlayCircle, color: 'var(--c3b82f6)' };
};

export default function CardTriagemIniciada({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconTriagemIniciada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const triagemIniciadaConfig = {
    tipo: 'triagem_iniciada',
    detectaTipo: detectaTriagemIniciada,
    getIcon: getIconTriagemIniciada,
    temExpansao: () => true,
    Component: CardTriagemIniciada
};

